<pr-panel>
  <pr-panel-body clazz="pal">
    <ea-gridky></ea-gridky>
  </pr-panel-body>
</pr-panel>

<!-- TITLES -->

<pr-panel>
  <pr-panel-body clazz="pal">
    <div class="grid-col-4 grid-col-xs-1 grid-col-sm-2 grid">
      <h1>Titre</h1>
      <h2>Titre</h2>
      <h3>Titre</h3>
      <h4>Titre</h4>
    </div>
  </pr-panel-body>
</pr-panel>

<!-- CARDS -->
<div class="grid-col-2 grid-col-xs-1 mbl grid">
  <pr-card [icon]="'add'" data-test-operation-count>
    <em value>11</em>
    <em title>Opérations en cours</em>
  </pr-card>
  <pr-card [icon]="'delete'" data-test-total-investment>
    <em title>TOTAL INVESTISSEMENT</em>
  </pr-card>
  <pr-card [icon]="'warning'">
    <em title>Valeur actuelle</em>
  </pr-card>
  <pr-card [icon]="'info'">
    <em value>24%</em>
    <em title>Rentabilité</em>
  </pr-card>
</div>

<div class="grid-col-4 grid-col-xs-1 grid-col-sm-2 mbl grid">
  <pr-card [icon]="'clock-o'">
    <em value>11</em>
    <em title>Opérations en cours</em>
  </pr-card>
  <pr-card [icon]="'times-circle-o'" [prColorizeText]="2">
    <em value>2</em>
    <em title>TOTAL INVESTISSEMENT</em>
  </pr-card>
  <pr-card [icon]="'tag'" [prColorizeText]="350000">
    <em value>{{ 350000 | currency: 'EUR' : 'symbol' : '.0-2' }}</em>
    <em title>Valeur actuelle</em>
  </pr-card>
  <pr-card [icon]="'star-o'" [prColorizeText]="-0.21">
    <em value>-21%</em>
    <em title>Rentabilité</em>
  </pr-card>
</div>

<!-- RADIO -->
<hr />
<h4>Radios</h4>
<pr-panel>
  <pr-panel-body clazz="pal">
    <div class="grid-col-4 grid-col-xs-1 grid-col-sm-2 grid">
      <pr-radio
        [choices]="[
          ['all', 'Tous'],
          ['positive', 'Positif'],
          ['neutral', 'Neutre'],
          ['negative', 'Negatif'],
        ]"
        (onSelectChoice)="onChoiceSelected($event)"
      >
      </pr-radio>
      <pr-radio
        [choices]="[
          ['all', 'Tous'],
          ['startDate', 'Date de début'],
          ['endDate', 'Date de fin'],
        ]"
        (onSelectChoice)="onChoiceSelected($event)"
      >
      </pr-radio>
      <pr-radio
        [choices]="[
          ['true', 'Oui'],
          ['false', 'Non'],
        ]"
        (onSelectChoice)="onChoiceSelected($event)"
      >
      </pr-radio>
      <pr-radio
        [choices]="[
          ['scpi', 'SCPI'],
          ['pinel', 'PINEL'],
          ['per', 'PER'],
        ]"
        (onSelectChoice)="onChoiceSelected($event)"
      >
      </pr-radio>
    </div>
  </pr-panel-body>
</pr-panel>

<!-- ARIANNE -->
<hr />
<h4>Arianne</h4>
<pr-breadcrumb></pr-breadcrumb>

<!-- BUTTON -->
<hr />
<h2>Buttons</h2>
<h4>Colors</h4>
<pr-panel>
  <pr-panel-body>
    <div class="grid-col-5 grid-col-xs-1 grid-col-sm-2 pas grid">
      <pr-button
        label="Ajouter un produit"
        display="neutral"
        size="lg"
      ></pr-button>
      <pr-button
        label="Ajouter un produit"
        display="info"
        size="lg"
      ></pr-button>
      <pr-button
        label="Ajouter un produit"
        display="success"
        size="lg"
      ></pr-button>
      <pr-button
        label="Ajouter un produit"
        display="warning"
        size="lg"
      ></pr-button>
      <pr-button
        label="Ajouter un produit"
        display="danger"
        size="lg"
      ></pr-button>
    </div>
  </pr-panel-body>
</pr-panel>
<pr-panel>
  <pr-panel-body>
    <div class="grid-col-5 grid-col-xs-1 grid-col-sm-2 pas grid">
      <pr-button
        label="Ajouter un produit"
        display="neutral"
        variant="outline"
        size="lg"
      ></pr-button>
      <pr-button
        label="Ajouter un produit"
        display="info"
        variant="outline"
        size="lg"
      ></pr-button>
      <pr-button
        label="Ajouter un produit"
        display="success"
        variant="outline"
        size="lg"
      ></pr-button>
      <pr-button
        label="Ajouter un produit"
        display="warning"
        variant="outline"
        size="lg"
      ></pr-button>
      <pr-button
        label="Ajouter un produit"
        display="danger"
        variant="outline"
        size="lg"
      ></pr-button>
    </div>
  </pr-panel-body>
</pr-panel>

<h4>With icons</h4>
<pr-panel>
  <pr-panel-body>
    <div class="grid-col-4 grid-col-xs-1 grid-col-sm-2 pas grid">
      <!-- <pr-button label="Ajouter un produit" display="neutral" size="lg" rightIcon="add"></pr-button> -->
      <pr-button
        label="Ajouter un produit"
        display="neutral"
        icon="add"
        size="lg"
      ></pr-button>
      <pr-button
        label="Ajouter un produit"
        display="info"
        size="lg"
        rightIcon="info"
      ></pr-button>
      <pr-button
        label="Ajouter un produit"
        display="success"
        icon="check"
        mobileIcon="true"
        size="lg"
      ></pr-button>
      <pr-button
        label="Ajouter un produit"
        display="warning"
        icon="warning"
        rightIcon="delete"
        size="lg"
      ></pr-button>
    </div>
  </pr-panel-body>
</pr-panel>

<h4>Icon only</h4>
<pr-panel>
  <pr-panel-body>
    <div class="grid-center grid-col-5 grid-col-xs-1 grid-col-sm-2 pas grid">
      <pr-button display="neutral" size="lg" icon="add"></pr-button>
      <pr-button display="info" size="lg" icon="info"></pr-button>
      <pr-button display="success" size="lg" icon="check"></pr-button>
      <pr-button display="warning" size="lg" icon="warning"></pr-button>
      <pr-button display="danger" size="lg" icon="delete"></pr-button>
    </div>
  </pr-panel-body>
</pr-panel>

<h4>Sizes</h4>
<pr-panel>
  <pr-panel-body>
    <div class="grid-center grid-col-4 grid-col-xs-1 grid-col-sm-2 pas grid">
      <pr-button
        label="Ajouter un produit"
        display="neutral"
        size="lg"
      ></pr-button>
      <pr-button label="Ajouter un produit" display="neutral"></pr-button>
      <pr-button display="neutral" size="lg" icon="add"></pr-button>
      <pr-button display="neutral" icon="add"></pr-button>
    </div>
  </pr-panel-body>
</pr-panel>

<!-- PRODUCT-SHEET -->
<hr />
<h2>Grid (auto-height)</h2>
<div class="grid-auto-height grid-col-2 grid-col-xs-1 mbl grid">
  <ea-product-sheet [showTitle]="true" [product]="'SCPI'"></ea-product-sheet>
  <ea-product-sheet [showTitle]="true" [product]="'PER'"></ea-product-sheet>
</div>

<h2>Grid (sans auto-height)</h2>
<div class="grid-col-2 grid-col-xs-1 mbl grid">
  <ea-product-sheet [showTitle]="false" [product]="'SCPI'"></ea-product-sheet>
  <ea-product-sheet [showTitle]="true" [product]="'PER'"></ea-product-sheet>
</div>

<!-- TABLE -->

<h2>Tableau</h2>
<div class="mbl"></div>

<h2>Tableau sans data</h2>
<div class="mbl"></div>

<h2>Tableau vide</h2>
<div class="mbl"></div>

<hr />
<h1>Composants Form</h1>
<hr />

<div class="grid-col-2 grid-col-xs-1 grid">
  <button class="pr-btn" (click)="startForm('assets')">
    Déclencher le formulaire Financier
  </button>
  <button class="pr-btn" (click)="startForm('estates')">
    Déclencher le formulaire Immobilier
  </button>
</div>
<hr />

<h2 class="mbl">Form</h2>

<pr-panel>
  <pr-form title="VOTRE PORTFEUILLE SUR MESURE " [formGroup]="form">
    <pr-input label="Texte simple">
      <input type="text" />
    </pr-input>

    <pr-input-date formControlName="date" label="Date"></pr-input-date>

    <pr-select-form
      formControlName="select"
      label="Selecteur"
      [options]="[
        { id: 'option 1', value: 1 },
        { id: 'option 2', value: 2 },
        { id: 'option 3', value: 3 },
      ]"
    >
    </pr-select-form>

    <pr-input-radio
      formControlName="radio"
      label="Bouton radio"
      [options]="[
        { value: true, label: 'Oui' },
        { value: false, label: 'Non' },
      ]"
    >
    </pr-input-radio>
  </pr-form>

  <hr />
  <ul>
    @for (control of form.value | keyvalue; track control) {
      <li>
        <span class="bold">{{ control.key }}</span> : {{ control.value }}
      </li>
    }
  </ul>
</pr-panel>
